import './TwoColumn.scss';
export {TwoColumn, MainColumn, SideColumn} from './TwoColumn.js';